export const chunkArrayInGroups = (data    , chunkSize        )       => {
	let result = [];
	for (let i = 0; i < data.length; i += chunkSize) {
		result.push(data.slice(i, i + chunkSize));
	}
	return result;
};
